import React from "react";
import "./DeactivateModal.css"; // Create a CSS file for styling
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoClose } from "react-icons/io5";

const DeactivateModal = ({ isOpen, onClose, children,heading }) => {
  return (
    <div
      className={`modal ${isOpen ? "show d-flex align-items-center justify-content-center" : ""}`}
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          maxWidth: "700px",
          width: "95%", // shrinks on small screens
          margin: "10px",
        }}
      >
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center flex-wrap">
            <h3 style={{ fontSize: "18px" }}>{heading}</h3>
            <button
              className="btn p-0 border-0 bg-transparent"
              onClick={onClose}
              style={{ lineHeight: 0 }}
            >
              <IoClose size={23} color="red" />
            </button>
          </div>
          <div className="modal-body p-2">{children}</div>
        </div>
      </div>
    </div>

  );
};

export default DeactivateModal;
